import request from '@/_helpers/requests/requestNotif'

export const bankService = {
    getBancos() {    
        return new Promise((resolve) => {    
            request.get('bank/datos').then(response => {
                resolve(response.data)
            });
        });
    },
    getPaises() {    
        return new Promise((resolve) => {    
            request.get('bank/paises').then(response => {
                resolve(response.data)
            });
        });
    }
};